import { Injectable } from '@angular/core';

import { PBConfigItem } from '../interfaces/presentation-builder-config.model';
import { PBValueData } from '../interfaces/presentation-builder-value-data.model';

@Injectable()
export abstract class PresentationBuilderValueAccessor<T> {
  abstract getValue(
    data: PBConfigItem<T>[],
    model: Record<string, unknown>,
    editorModel?: Record<string, string>
  ): PBValueData[];
}
